import React from "react";
import Seller from "components/Tvendo/Sale/DataMaster/Seller/List.js";
export default function () {
  return <Seller />;
}
